module.exports = __webpack_public_path__ + "static/media/Eterno Fabric Left Arm Sofa_Green.0ef0a84d.png";